import routersDetails from './routersDetails'

export default {
    ...routersDetails
}


// WEBPACK FOOTER //
// ./src/router/routersAll.js